
import React from 'react';
import { useTranslation } from 'react-i18next';
import './Logo.css';

interface LogoProps {
    fontSize?: string;
    className?: string;
    showPro?: boolean;
    contrast?: boolean;
}

const Logo: React.FC<LogoProps> = ({
    fontSize = '1.6rem',
    className = '',
    showPro = true,
    contrast = false
}) => {
    const { t } = useTranslation('login');

    return (
        <span 
            className={`rintintin-logo-container ${contrast ? 'rintintin-logo--contrast' : ''} ${className}`} 
            style={{ fontSize }}
            aria-label={t('title')}
        >
            <span className="logo-text-main">Rintintin</span>{showPro && <span className="logo-text-pro">Pro</span>}<span className="logo-dot">.</span>
        </span>
    );
};

export default Logo;
